export default class Shop {
  constructor({ banners, catalog, city, id, logo, name, service, services, socials }) {
    this.banners = banners;
    this.catalog = catalog;
    this.city = city;
    this.id = id;
    this.logo = logo;
    this.name = name;
    this.service = service;
    this.services = services;
    this.socials = socials;
  }

  static format(shop, service = 'eatin') {
    const label = `${shop.title.split(' ').join('')}`;
    const socials = [
      { label , type: 'instagram', icon: '/statics/images/icons/social/instagram.svg', href: !['', null, undefined].includes(shop.instagram_page) ? shop.instagram_page : null },
      { label, type: 'facebook', icon: '/statics/images/icons/social/facebook.svg', href: !['', null, undefined].includes(shop.facebook_page) ? shop.facebook_page : null },
      { label, type: 'messenger', icon: '/statics/images/icons/social/messenger.svg', href: !['', null, undefined].includes(shop.messenger_page) ? shop.messenger_page : null },
      { label, type: 'pinterest', icon: '/statics/images/icons/social/pinterest.svg', href: !['', null, undefined].includes(shop.pinterest_page) ? shop.pinterest_page : null },
      { label: `@${label}`, type: 'twitter', icon: '/statics/images/icons/social/twitter.svg', href: !['', null, undefined].includes(shop.twitter_page) ? shop.twitter_page : null },
      { label, type: 'youtube', icon: '/statics/images/icons/social/youtube.svg', href: !['', null, undefined].includes(shop.youtube_page) ? shop.youtube_page : null },
    ];

    return {
      banners: shop.banners,
      catalog: shop.services[service].menu_id,
      city: shop.address.city,
      id: shop.id,
      logo: shop.logo,
      name: shop.title,
      service: shop.services[service],
      services: shop.services,
      socials: socials
    }
  }
}